import * as yup from "yup";
import validation, {
  expiryValidate,
  phoneValidate,
  citizenValidate,
  postCodeValidate,
  emailValidate,
  textOnlyValidate,
  mobilePhoneValidate,
  objectMinCountValidate,
} from "@/helpers/validation";

export const paymentCreditCard = () => {
  return yup.object().shape({
    cardNumber: yup
      .number()
      .min(15, "จำนวนเลขบัตรไม่ถุกต้อง")
      .required("กรุณาระบุหมายเลขบัตร")
      .typeError("กรุณากรอกเฉพาะตัวเลข"),
    cardholdername: yup.string().required("กรุณาระบุชื่อ"),
    expiryMonth: yup
      .number()
      .required("กรุณาระบุเดือนหมดอายุ")
      .typeError("กรุณากรอกเฉพาะตัวเลข"),
    expiryYear: yup
      .number()
      .required("กรุณาระบุปีหมดอายุ")
      .typeError("กรุณากรอกเฉพาะตัวเลข"),
    cvv: yup.number().required("กรุณาระบุรหัส ccv"),
  });
};
export const staffCodeSchema = () => {
  return yup.object().shape({
    s: yup.string().required(),
  });
};
export const utmSchema = () => {
  return yup.object().shape({
    utm_source: yup.string().required(),
    utm_medium: yup.string().required(),
    utm_campaign: yup.string(),
    utm_term: yup.string(),
  });
};
export const homeInfoSchema = () => {
  return yup.object().shape({
    homeType: yup.string().required(),
    homeStructure: yup.string().required(),
    homeSqm: yup.string().required(),
  });
};
export const homeLocationSchema = () => {
  return yup.object().shape({
    postCode: yup
      .string()
      .required("กรุณากรอกรหัสไปรษณีย์")
      .max(5, "รหัสไปรษณีย์ของคุณเกินจำนวน"),
    province: yup.string().required("กรุณาเลือกจังหวัด"),
    district: yup.string().required("กรุณาเลือกเขตหรืออำเภอ"),
    subDistrict: yup.string().required("กรุณาเลือกแขวงหรือตำบล"),
    // homeAsset: yup
    //   .number()
    //   .moreThan(0, "กรุณากรอกมูลค่าทรัพย์สิน")
    //   .required(""),
    // homeFurniture: yup
    //   .number()
    //   .moreThan(0, "กรุณากรอกมูลค่าทรัพย์สิน")
    //   .required("กรุณากรอกมูลค่าทรัพย์สิน"),
    // homeValueAsset: yup.number().moreThan(0, "กรุณากรอกมูลค่าทรัพย์สิน").required('กรุณากรอกมูลค่าทรัพย์สิน'),
  });
};
export const homeInfoExtendedSchema = () => {
  return yup.object().shape({
    homeType: yup.string().required("กรุณาเลือกประเภทที่อยู่อาศัย"),
    homeStructure: yup.string().required("กรุณาเลือกโครงสร้างบ้าน"),
    homeFloor: yup.number().required("กรุณาเลือกจำนวนชั้น"),
    homeSqm: yup
      .number()
      .moreThan(0, "กรุณากรอกพื้นที่ใช้สอย")
      .required("กรุณากรอกพื้นที่ใช้สอย"),
    homeUsage: yup.string().required("กรุณาเลือกประเภทการใช้งาน"),
    homeFurniture: yup.string().required("กรุณาเลือกมูลค่า"),
    homeApplicant: yup.string().required("กรุณาเลือกมูลค่า"),
    firstName: yup
      .string()
      .max(50, "ชื่อของคุณเกินจำนวนที่กำหนด")
      .required("กรุณากรอกชื่อจริง")
      .test("firstName", "กรุณากรอกชื่อให้ถูกต้อง", textOnlyValidate),
    lastName: yup
      .string()
      .max(50, "นามสกุลของคุณเกินจำนวนที่กำหนด")
      .required("กรุณากรอกนามสกุล")
      .test("lastName", "กรุณากรอกนามสกุลให้ถูกต้อง", textOnlyValidate),
    phone: yup
      .string()
      .required("กรุณากรอกเบอร์โทรศัพท์")
      .test("phone", "เบอร์โทรศัพท์ไม่ถูกต้อง", mobilePhoneValidate),
    // consent: yup.bool().oneOf([true], "กรุณายอมรับเงื่อนไข").required(),
  });
};
export const selectedProductSchema = () => {
  return yup.object().shape({
    id: yup.number().required(),
    imageUrl: yup.string().required(),
    title: yup.string().required(),
    maxCoverage: yup.string().required(),
    insurer: yup.string().required(),
    planProductVariantId: yup.number().required(),
    // expiry: yup.date().required().test(expiryValidate),
  });
};
export const customerDropleadInfoSchema = () => {
  return yup.object().shape({
    firstName: yup
      .string()
      .max(50, "ชื่อของคุณเกินจำนวนที่กำหนด")
      .required("กรุณากรอกชื่อจริง")
      .test("firstName", "กรุณากรอกชื่อให้ถูกต้อง", textOnlyValidate),
    lastName: yup
      .string()
      .max(50, "นามสกุลของคุณเกินจำนวนที่กำหนด")
      .required("กรุณากรอกนามสกุล")
      .test("lastName", "กรุณากรอกนามสกุลให้ถูกต้อง", textOnlyValidate),
    phone: yup
      .string()
      .required("กรุณากรอกเบอร์โทรศัพท์")
      .test("phone", "เบอร์โทรศัพท์ไม่ถูกต้อง", mobilePhoneValidate),
    // consent: yup.bool().oneOf([true], "กรุณายอมรับเงื่อนไข").required(),
  });
};
export const customerInfoSchema = () => {
  return yup.object().shape({
    firstName: yup
      .string()
      .max(50, "ชื่อของคุณเกินจำนวนที่กำหนด")
      .required("กรุณากรอกชื่อจริง")
      .test("firstName", "กรุณากรอกชื่อให้ถูกต้อง", textOnlyValidate),
    lastName: yup
      .string()
      .max(50, "นามสกุลของคุณเกินจำนวนที่กำหนด")
      .required("กรุณากรอกนามสกุล")
      .test("lastName", "กรุณากรอกนามสกุลให้ถูกต้อง", textOnlyValidate),
    prefix: yup.string().required("กรุณากรอกเลือกคำนำหน้า"),
    phone: yup
      .string()
      .required("กรุณากรอกเบอร์โทรศัพท์")
      .test("phone", "เบอร์โทรศัพท์ไม่ถูกต้อง", mobilePhoneValidate),
    dob: yup
      .date()
      .required("กรุณากรอกวันเดือนปีเกิด")
      .typeError("วันเกิดไม่ถูกต้อง"),
    citizen: yup
      .string()
      .required("กรุณากรอกเลขบัตรประชาชน")
      .test("citizen", "เลขบัตรประชาชนไม่ถูกต้อง", citizenValidate),
    // consent: yup.bool().oneOf([true], "กรุณายอมรับเงื่อนไข").required(),
  });
};
export const customerAddressSchema = () => {
  return yup.object().shape({
    houseAddressHouseNumber: yup
      .string()
      .max(10, "เลขที่บ้านของคุณเกินจำนวนที่กำหนด")
      .required("กรุณากรอกเลขที่บ้าน"),
    houseAddressVillageName: yup
      .string()
      .max(30, "ชื่อหมู่บ้านของคุณเกินจำนวนที่กำหนด"),
    houseAddressLocation: yup.object({
      postCode: yup
        .string()
        .required("กรุณากรอกรหัสไปรษณีย์")
        .max(5, "รหัสไปรษณีย์ของคุณเกินจำนวน"),
      province: yup.string().required("กรุณาเลือกจังหวัด"),
      district: yup.string().required("กรุณาเลือกเขตหรืออำเภอ"),
      subDistrict: yup.string().required("กรุณาเลือกแขวงหรือตำบล"),
    }),
    houseStructure: yup
      .string()
      .required("กรุณาเลือกรูปแบบโครงสร้างบ้านของคุณ"),
    houseType: yup.string().required("กรุณาเลือกประเภทบ้านของคุณ"),
    houseSqm: yup.number().required("กรุณากรอกพื้นที่ใช้สอยในบ้าน"),
    houseFloor: yup.number().required("กรุณากรอกจำนวนชั้น"),
    email: yup
      .string()
      .email("อีเมลของคุณไม่ถูกต้อง")
      .required("กรุณากรอกอีเมล"),
    insuranceReceiveChannel: yup
      .string()
      .required("กรุณาเลือกช่องทางการจัดส่งกรมธรรม์"),
    // ownerEmail: yup.string().when("insuranceReceiveChannel", {
    //   is: "email",
    //   then: yup
    //     .string()
    //     .email("อีเมลจัดส่งของคุณไม่ถูกต้อง")
    //     .required("กรุณาระบุอีเมล"),
    // }),
    postalSameAddress: yup.boolean(),
    ownerProvince: yup
      .object()
      .when(["insuranceReceiveChannel", "postalSameAddress"], {
        is: (insuranceReceiveChannel, postalSameAddress) =>
          insuranceReceiveChannel == "postal" && postalSameAddress == false,
        then: yup.object().shape({
          postCode: yup
            .string()
            .required("กรุณากรอกรหัสไปรษณีย์")
            .max(5, "รหัสไปรษณีย์ของคุณเกินจำนวน"),
          province: yup.string().required("กรุณาเลือกจังหวัด"),
          district: yup.string().required("กรุณาเลือกเขตหรืออำเภอ"),
          subDistrict: yup.string().required("กรุณาเลือกแขวงหรือตำบล"),
        }),
      }),
    ownerAddressHouseNumber: yup
      .string()
      .when(["insuranceReceiveChannel", "postalSameAddress"], {
        is: (insuranceReceiveChannel, postalSameAddress) =>
          insuranceReceiveChannel == "postal" && postalSameAddress == false,
        then: yup
          .string()
          .max(10, "เลขที่บ้านของคุณเกินจำนวนที่กำหนด")
          .required("กรุณากรอกเลขที่บ้าน"),
      }),
    ownerAddressVillageName: yup
      .string()
      .when(["insuranceReceiveChannel", "postalSameAddress"], {
        is: (insuranceReceiveChannel, postalSameAddress) =>
          insuranceReceiveChannel == "postal" && postalSameAddress == false,
        then: yup.string().max(30, "ชื่อหมู่บ้านของคุณเกินจำนวนที่กำหนด"),
      }),
    // consent: yup.bool().oneOf([true], "กรุณายอมรับเงื่อนไข").required(),
  });
};

export const smeCustomerSchema = () => {
  return yup.object().shape({
    homeType: yup.string().required("กรุณาเลือกประเภทที่อยู่อาศัย"),
    homeStructure: yup.string().required("กรุณาเลือกโครงสร้างบ้าน"),
    homeFloor: yup
      .number()
      .moreThan(0, "กรุณาเลือกจำนวนชั้น")
      .required("กรุณาเลือกจำนวนชั้น"),
    homeUsage: yup.string().required("กรุณาเลือการใช้งานบ้าน"),
    businessType: yup
      .string()
      .required(
        "กรุณาระบุธุรกิจของคุณ ตัวอย่าง : ร้านเสริมสวย, ร้านอิงเจท, ร้านขายของชำร่วย, ขายของออนไลน์"
      ),
    hadInsurance: yup.boolean().required("กรุณาเลือกว่าเคยหรือไม่"),
    firstName: yup
      .string()
      .max(50, "ชื่อของคุณเกินจำนวนที่กำหนด")
      .required("กรุณากรอกชื่อจริง")
      .test("firstName", "กรุณากรอกชื่อให้ถูกต้อง", textOnlyValidate),
    lastName: yup
      .string()
      .max(50, "นามสกุลของคุณเกินจำนวนที่กำหนด")
      .required("กรุณากรอกนามสกุล")
      .test("lastName", "กรุณากรอกนามสกุลให้ถูกต้อง", textOnlyValidate),
    phone: yup
      .string()
      .required("กรุณากรอกเบอร์โทรศัพท์")
      .test("phone", "เบอร์โทรศัพท์ไม่ถูกต้อง", mobilePhoneValidate),
    businessImage: yup
      .object()
      .required()
      .test("businessImage", "กรุณา upload 2 รูปขึ้นไป", (value) =>
        objectMinCountValidate(value, 1)
      ),
    // consent: yup.bool().oneOf([true], "กรุณายอมรับเงื่อนไข").required(),
  });
};

export const headerDropLeadFromSchema = () => {
  return yup.object().shape({
    firstName: yup
      .string()
      .max(50, "ชื่อของคุณเกินจำนวนที่กำหนด")
      .required("กรุณากรอกชื่อ")
      .test("firstName", "กรุณากรอกชื่อให้ถูกต้อง", textOnlyValidate),
    lastName: yup
      .string()
      .max(50, "นามสกุลของคุณเกินจำนวนที่กำหนด")
      .required("กรุณากรอกนามสกุล")
      .test("lastName", "กรุณากรอกนามสกุลให้ถูกต้อง", textOnlyValidate),
    phone: yup
      .string()
      .required("กรุณากรอกเบอร์โทรศัพท์มือถือ")
      .test("phone", "เบอร์โทรศัพท์มือถือไม่ถูกต้อง", mobilePhoneValidate),
    // consent: yup.bool().oneOf([true], "กรุณายอมรับเงื่อนไข").required(),
  });
};

export const condoDropLeadFormSchema = () => {
  return yup.object().shape({
    firstName: yup
      .string()
      .max(50, "ชื่อของคุณเกินจำนวนที่กำหนด")
      .required("กรุณากรอกชื่อ")
      .test("firstName", "กรุณากรอกชื่อให้ถูกต้อง", textOnlyValidate),
    lastName: yup
      .string()
      .max(50, "นามสกุลของคุณเกินจำนวนที่กำหนด")
      .required("กรุณากรอกนามสกุล")
      .test("lastName", "กรุณากรอกนามสกุลให้ถูกต้อง", textOnlyValidate),
    phone: yup
      .string()
      .required("กรุณากรอกเบอร์โทรศัพท์มือถือ")
      .test("phone", "เบอร์โทรศัพท์มือถือไม่ถูกต้อง", mobilePhoneValidate),
    contactTime: yup
      .string()
      .required("กรุณาเลือกช่วงเวลาที่สะดวกให้ติดต่อกลับ"),
  });
};
